<template>
	<ul class="login-slideshow">
		<transition name="slide" v-for="n in this.slideCount" :key="n">
			<li class="slide" v-bind:class="slideClass(n)" v-if="currentSlide == n"></li>
		</transition>
	</ul>
</template>

<script>
	export default {
		data() {
			return {
				slideCount: 15,
				currentSlide: 1,
				delay: 3000
			}
		},
		methods: {
			slideClass: (id) => {
				return 'slide-' + ('0' + id).substr(-2)
			}
		},
		watch: {
			currentSlide: {
				immediate: true,
				handler: function() {
					setTimeout(() => {
						this.currentSlide++;
						if (this.currentSlide > 15) this.currentSlide = 1;
					}, this.delay);
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/HomeSlideshow.vue